export default {
  title: 'Configuração de SLA',
  description: 'Defina o SLA com base na data de abertura ou agendamento para garantir prazos de atendimento claros.',
  checklist: 'Questionário *',
  place: 'Local *',
  startCount: 'Início da contagem *',
  unit: 'Unidade de contagem *',
  slaValue: 'Prazo do SLA *',
  warning: 'O SLA será calculado com base na configuração vigente no momento da criação da atividade.'
}
